module.exports = __webpack_public_path__ + "static/7040-b76b522fd5268079aa13f6c8810623d2.jpg";